import useGetState from './use-get-state.js';
/**
 * This hook provides synchronous access to a service request and will keep
 * the previous request while loading.
 *
 * @template SVC
 * @param {({
 *     serviceState: IServiceState<SVC>|IAnonymousServiceState<SVC>,
 *     defaultValue?: SVC['request'],
 *   })} {
 *     serviceState,
 *     defaultValue,
 *   }
 * @returns
 */
export const useGetServiceRequest = (serviceState, defaultValue) => {
    return useGetState(serviceState.request, defaultValue);
};
export default useGetServiceRequest;
//# sourceMappingURL=use-get-service-request.js.map